import gql from 'graphql-tag';

export const transientPersonManagementDetailsFragment = gql`
  fragment transientPersonManagementDetailsParts on TransientPersonDetails {
    name
    value
    type
    isMasked
  }
`;

export const transientPersonManagementWithDetailsFragment = gql`
  fragment transientPersonManagementWithDetailsParts on TransientPersonWithDetails {
    id
    name
    partnerPersonContextId
    type
    faceId
    transientPersonDetails {
      ...transientPersonManagementDetailsParts
    }
  }
  ${transientPersonManagementDetailsFragment}
`;

export const transientPersonManagementResponseFragment = gql`
  fragment transientPersonManagementResponseParts on TransientPersonManagementResponse {
    collection {
      ...transientPersonManagementWithDetailsParts
    }
    pagination {
      page
      pageSize
      hasNextPage
    }
  }
  ${transientPersonManagementWithDetailsFragment}
`;

export const transientPersonCondominiumOptionFragment = gql`
  fragment transientPersonCondominiumOptionParts on TransientPersonCondominiumOption {
    condominiumPersonContextId
    name
    enabledTypes
  }
`;
